import React from 'react';
import Link from 'gatsby-link';
import { css } from 'glamor';

export const navButtons = css({
  textDecoration: 'none',
  display: 'inline-block',
  padding: '8px 16px',
  borderRadius: '50%',
})

export const disabled = css({
  color:'gray'
})


export const NavLink = props => {
  if (!props.test) {
    return <Link to={props.url} {...css(navButtons)}>{props.children}</Link>;
  }
  else {
    return <span {...css(navButtons, disabled)}>{props.children}</span>;
  }
};


// WEBPACK FOOTER //
// ./src/components/NavLink.js